import {Usuario} from '../models/usuarios/usuario.model';

export var GlobalData = {
  bDebugMode: false,
  modo: 'list',
  usuario: {},

  isInDebugMode(): boolean {
    return this.bDebugMode;
  },
  getUsuario(): Usuario {
    return this.usuario;
  }
};



// WEBPACK FOOTER //
// ./src/app/globaldata.ts